import React from "react";

import * as ResourceApi from "api/resources";
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import {
	createButtonSectionFactory,
	createButtonSectionFactoryWithAdditionalArgs,
} from "hoc/CreateButtonSection";
import { FormattedMessage, IntlProvider } from "react-intl";
import { enUSmessage } from "i18n/en-US.js";

const isGenAI = (proxy) => {
	return proxy.currentResource.hasGenAI === true;
};

export default {
	name: "grocery",
	subSection: true,
	resource: true,
	hideIfResourceIsNoU: true,

	fields: [
		{
			type: "yesnoradio",
			name: "hasGenAI",
			required: true,
			props: {
				labelKey: "Enable Gen AI Mode",
			},
		},
		{
			type: "contenteditable",
			name: "title",
			required: false,

			props: {
				labelKey: "editbreak.steps.grocery.title",
			},
		},
		{
			type: "contenteditable",
			name: "copy",
			required: false,
			props: {
				labelKey: "editbreak.steps.grocery.copy",
			},
		},
		{
			type: "radio",
			name: "contentLanguage",
			required: false,
			props: {
				labelKey: "editbreak.steps.grocery.contentLanguage",
				options: [
					{
						value: "EN_US",
						textKey: "editbreak.steps.grocery.contentLanguage.EN_US",
					},
					{
						value: "ES_LA",
						textKey: "editbreak.steps.grocery.contentLanguage.ES_LA",
					},
				],
			},
		},
		{
			type: "image",
			name: "headerImageId",
			idFor: "headerImage",
			showField: (proxy) => isGenAI(proxy),
			required: false,
			props: {
				labelKey: "Intro Header Image (670 x 290)",
				imageType: "custom",
			},
		},

		{
			type: "hardcodedText",
			showField: (proxy) => isGenAI(proxy),
			props: {
				heading: "Result - Gen AI",
			},
		},
		{
			type: "text",
			name: "genAIPrompt",
			required: true,
			showField: (proxy) => {
				//   console.log(`currentResource`, proxy.currentResource) // item
				//   console.log(`parentCurrentResource`, proxy.parentCurrentResource) // checklist
				//   console.log(`grandParentCurrentResource`, proxy.grandParentCurrentResource) // grocery
				// console.log(proxy.parentCurrentResource.hasGenAI)
				return proxy.currentResource.hasGenAI === true;
			},

			props: {
				labelKey: "editbreak.steps.grocery.genAiPrompt",
				helperText:
					'We have to call Open AI\'s API for each recipe, so the prompt should start with "Generate 1 recipe that includes..."',
			},
		},
		{
			type: "number",
			name: "genAIResultsNumber",
			showField: (proxy) => isGenAI(proxy),
			required: false,
			props: {
				labelKey: "editbreak.steps.grocery.genAiResultsNumber",
			},
		},

		{
			type: "hardcodedText",
			props: {
				heading: "Checklists",
			},
		},

		//Array of individual checklists.
		//This field is an array of checklist groups.
		{
			name: "groceryChecklists",
			subSection: true,
			resource: true,
			collection: true,
			sectionWrapper: IndexedSubSectionWrapper,
			deletable: true,
			canDelete: (formProxy) => {
				// logic like this would force at least one item
				//   var parentReview = formProxy.parentCurrentResource;
				//   return parentReview.products && parentReview.products.length > 1;
				return true;
			},
			sortable: true,
			sortableName: "groceryChecklistsOrder",
			toggleSortLabelKey: "editbreak.steps.grocery.checklist.reorder_toggle",
			resourceType: ResourceApi.Types.GroceryChecklist,

			props: {
				headerKey: "editbreak.steps.grocery.checklist.section_header",
				getCustomSectionHeader: (checklist, sectionIndex) => {
					return checklist.title
						? checklist.title
						: `checklist - ${sectionIndex + 1}`;
					// return product.dropdownTitle
					// && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
				},
			},

			footerContent: createButtonSectionFactory(
				ResourceApi.Types.GroceryChecklist
			),

			fields: [
				{
					type: "contenteditable",
					name: "title",
					required: false,
					props: {
						labelKey: "editbreak.steps.grocery.checklist.title",
					},
				},

				{
					type: "contenteditable",
					name: "copy",
					required: false,
					props: {
						labelKey: "editbreak.steps.grocery.checklist.copy",
					},
				},

				{
					type: "dropdown",
					name: "imageType",
					required: true,

					props: {
						labelKey: "editbreak.steps.grocery.checklist.imageType",
						options: [
							{
								value: "NONE",
								textKey: "editbreak.steps.grocery.checklist.imageType.none",
							},
							{
								value: "SQUARE",
								textKey: "editbreak.steps.grocery.checklist.imageType.square",
							},
							{
								value: "VERTICAL",
								textKey: "editbreak.steps.grocery.checklist.imageType.vertical",
							},
							{
								value: "HORIZONTAL",
								textKey:
									"editbreak.steps.grocery.checklist.imageType.horizontal",
							},
						],
					},
				},
				{
					type: "image",
					name: "imageId",
					idFor: "image",
					required: false,
					props: {
						labelKey: "editbreak.steps.grocery.checklist.image",
						imageType: "grocerySquare",
					},
					showField: (proxy) => {
						return proxy.currentResource.imageType === "SQUARE";
					},
				},

				{
					type: "image",
					name: "imageId",
					idFor: "image",
					required: false,
					props: {
						labelKey: "editbreak.steps.grocery.checklist.image",
						imageType: "groceryVertical",
					},
					showField: (proxy) => {
						return proxy.currentResource.imageType === "VERTICAL";
					},
				},

				{
					type: "image",
					name: "imageId",
					idFor: "image",
					required: false,
					props: {
						labelKey: "editbreak.steps.grocery.checklist.image",
						imageType: "groceryHorizontal",
					},
					showField: (proxy) => {
						return proxy.currentResource.imageType === "HORIZONTAL";
					},
				},

				// a prompt for this set of items
				{
					type: "text",
					name: "genAIPromptText",
					showField: (proxy) => {
						// console.log(`currentResource`, proxy.currentResource) // item
						// console.log(`parentCurrentResource`, proxy.parentCurrentResource) // checklist
						// console.log(`grandParentCurrentResource`, proxy.grandParentCurrentResource) // grocery
						// console.log(proxy.grandParentCurrentResource.hasGenAI)
						return proxy.parentCurrentResource.hasGenAI === true;
					},
					required: false,
					props: {
						labelKey: "Gen AI Prompt Text (for this group of items)",
					},
				},

				{
					type: "radio",
					name: "selectionMode",
					// showField: (proxy) => isGenAI(proxy),
					showField: (proxy) => proxy.parentCurrentResource.hasGenAI === true,
					required: true,
					props: {
						labelKey: "Display options as radio buttons or checkboxes",
						options: [
							{
								value: "ONE",
								text: "Radio buttons - must select one option",
							},
							{
								value: "ZERO_OR_MORE",
								text: "Checkboxes - not required",
							},
							// {
							//     value: 'ONE_OR_MORE',
							//     text: 'Checkboxes - at least 1 option must be selected'
							// }
						],
					},
				},

				// The individual checkable items inside each checklist.
				{
					name: "items",
					subSection: true,
					resource: true,
					collection: true,
					sectionWrapper: IndexedSubSectionWrapper,
					deletable: true,
					canDelete: (formProxy) => {
						// logic like this would force at least one item
						//   var parentReview = formProxy.parentCurrentResource;
						//   return parentReview.products && parentReview.products.length > 1;
						return true;
					},
					sortable: true,
					sortableName: "itemsOrder",
					resourceType: ResourceApi.Types.GroceryChecklistItem,
					toggleSortLabelKey:
						"editbreak.steps.grocery.checklist.item.reorder_toggle",
					props: {
						headerKey: "editbreak.steps.grocery.checklist.item.section_header",
						getCustomSectionHeader: (item, sectionIndex) => {
							return item.label ? item.label : `item - ${sectionIndex + 1}`;
							// return product.dropdownTitle
							// && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
						},
					},

					footerContent: createButtonSectionFactory(
						ResourceApi.Types.GroceryChecklistItem
					),

					fields: [
						{
							type: "hardcodedText",
							props: {
								heading: "Checklist Item",
							},
						},
						{
							type: "contenteditable",
							name: "label",
							required: true,
							props: {
								// labelKey: "editbreak.steps.grocery.checklist.item.label",
								label: "Checklist item text",
							},
						},
						{
							type: "text",
							name: "genAIPromptText",
							showField: (proxy) => {
								// console.log(`currentResource`, proxy.currentResource) //
								// console.log(`parentCurrentResource`, proxy.parentCurrentResource) //
								// console.log(`grandParentCurrentResource`, proxy.grandParentCurrentResource) //
								// console.log(proxy.grandParentCurrentResource.hasGenAI)
								return proxy.grandParentCurrentResource.hasGenAI === true;
							},
							required: false,
							props: {
								labelKey:
									"editbreak.steps.grocery.checklist.item.genAIPromptText",
							},
						},
						{
							type: "contenteditable",
							name: "keyIngredient",
							showField: (proxy) => {
								return proxy.grandParentCurrentResource.hasGenAI === true;
							},
							required: false,
							props: {
								labelKey: "Key Ingredient",
							},
						},
						{
							type: "image",
							name: "itemImageId",
							idFor: "itemImage",
							required: false,
							props: {
								labelKey: "Product Image",
								imageType: "custom",
							},
							showField: (proxy) => {
								// console.log(`proxy.grandParentCurrentResource.hasGenAI`, proxy.grandParentCurrentResource.hasGenAI)
								return proxy.grandParentCurrentResource.hasGenAI === true;
							},
						},
						//   {
						//     subSection: true,
						//     resource: true,
						//     // key: "editbreak.steps.grocery.resultLink.header",
						//     sectionWrapper: IndexedSubSectionWrapper,
						//     props: {
						//       'headerKey': 'Dropdown Buttons',
						//     },
						//     fields: [

						{
							name: "dropdownButtons",
							subSection: true,
							resource: true,
							collection: true,
							sectionWrapper: IndexedSubSectionWrapper,
							deletable: true,
							canDelete: (formProxy) => {
								// logic like this would force at least one item
								//   var parentReview = formProxy.parentCurrentResource;
								//   return parentReview.products && parentReview.products.length > 1;
								return true;
							},
							sortable: true,
							sortableName: "itemButtonOrder",
							resourceType: ResourceApi.Types.GroceryDropdownButton,
							toggleSortLabelKey:
								"editbreak.steps.grocery.resultLink.reorder_toggle",
							props: {
								headerKey: "Button Links",
								getCustomSectionHeader: (item, sectionIndex) => {
									// console.log("custom header", item)
									if (!item.links) {
										item.links = [];
									}

									let links = item.links.filter((item) => {
										return item.deleted === false;
									});
									if (links.length > 1) {
										return item.buttonCopy
											? item.buttonCopy
											: `dropdownbutton - ${sectionIndex + 1}`;
									} else if (links.length === 1) {
										return links[0].label;
									} else {
										return `dropdownbutton - ${sectionIndex + 1}`;
									}
								},
							},

							footerContent: createButtonSectionFactoryWithAdditionalArgs(
								{
									extra: "extra",
								},
								ResourceApi.Types.GroceryDropdownButton
							),

							fields: [
								{
									type: "hardcodedText",
									key: "links-helper",
									props: {
										text: "If you include a single link, the UI will show a button. Incude multiple links and the UI will show a dropdown button.",
									},
								},
								{
									type: "contenteditable",
									name: "label",
									required: false,
									props: {
										labelKey: "Button Copy",
									},
									showField: (proxy) => {
										let links = proxy.currentResource.links.filter((item) => {
											return item.deleted === false;
										});

										return links.length > 1;
									},
								},
								{
									name: "links",
									subSection: true,
									resource: true,
									collection: true,
									sectionWrapper: IndexedSubSectionWrapper,
									deletable: true,
									canDelete: (formProxy) => {
										// logic like this would force at least one item
										//   var parentReview = formProxy.parentCurrentResource;
										//   return parentReview.products && parentReview.products.length > 1;
										return true;
									},
									sortable: true,
									sortableName: "linksOrder",
									resourceType: ResourceApi.Types.GroceryDropdownButtonLink,
									toggleSortLabelKey:
										"editbreak.steps.grocery.resultLink.reorder_toggle",
									props: {
										//headerKey: 'editbreak.steps.grocery.resultLink.section_header',
										getCustomSectionHeader: (item, sectionIndex) => {
											return item.label
												? item.label
												: `Link - ${sectionIndex + 1}`;
											// return product.dropdownTitle
											// && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
										},
									},

									footerContent: createButtonSectionFactory(
										ResourceApi.Types.GroceryDropdownButtonLink
									),

									fields: [
										{
											type: "contenteditable",
											name: "label",
											required: false,
											props: {
												labelKey: "Label",
											},
										},
										{
											type: "text",
											name: "url",
											required: false,
											props: {
												labelKey: "Url",
											},
										},
									],
								},
							],
						},
						//     ]
						//   },

						// On grocery checklist, results are created automatically from selections.
						// The following fields are used to populate info in the result card for this item
						// Grocery checklist settings
						// grocery Checklist result type includes a specialty cta button
						{
							type: "text",
							name: "url",
							showField: (proxy) => {
								// console.log(currentResource) // item
								// console.log(proxy.parentCurrentResource) // checklist
								// console.log(proxy.grandParentCurrentResource) // grocery
								// console.log(proxy.grandParentCurrentResource.resultDisplayType)

								return (
									proxy.grandParentCurrentResource.resultDisplayFormat ===
									"CARDS"
								);
							},
							required: false,
							props: {
								labelKey: "editbreak.steps.grocery.checklist.item.url",
							},
						},
						//
						{
							type: "text",
							name: "buttonCopy",
							showField: (proxy) => {
								return (
									proxy.grandParentCurrentResource.resultDisplayFormat ===
									"CARDS"
								);
							},
							required: false,
							props: {
								labelKey: "editbreak.steps.grocery.checklist.item.buttonCopy",
							},
						},

						{
							type: "image",
							name: "imageId",
							showField: (proxy) => {
								return (
									proxy.grandParentCurrentResource.resultDisplayFormat ===
									"CARDS"
								);
							},
							idFor: "image",
							required: false,
							props: {
								labelKey: "editbreak.steps.grocery.checklist.item.image",
								imageType: "referral3x2",
							},
						},
					],
				},
			],
		},

		{
			type: "hardcodedText",
			props: {
				heading: "Result",
			},
		},
		{
			type: "contenteditable",
			name: "resultTitle",
			required: true,

			props: {
				labelKey: "editbreak.steps.grocery.title",
			},
		},
		{
			type: "contenteditable",
			name: "resultCopy",
			required: false,
			props: {
				labelKey: "editbreak.steps.grocery.copy",
			},
		},
		{
			type: "image",
			name: "resultImageId",
			idFor: "resultImage",
			required: false,
			props: {
				labelKey: "Result Image (670 x 290)",
				imageType: "custom",
			},
		},

		{
			type: "radio",
			name: "resultInclude",
			showField: (proxy) => !isGenAI(proxy),
			required: false,
			props: {
				labelKey: "editbreak.steps.grocery.resultInclude",
				options: [
					{
						value: "SELECTED",
						textKey: "editbreak.steps.grocery.resultInclude.SELECTED",
					},
					{
						value: "UNSELECTED",
						textKey: "editbreak.steps.grocery.resultInclude.UNSELECTED",
					},
				],
			},
		},
		{
			type: "radio",
			name: "resultDisplayFormat",
			required: false,
			showField: (proxy) => !isGenAI(proxy),
			props: {
				labelKey: "editbreak.steps.grocery.resultDisplayFormat",
				options: [
					{
						value: "LIST",
						textKey: "editbreak.steps.grocery.resultDisplayFormat.LIST",
					},
					{
						value: "CARDS",
						textKey: "editbreak.steps.grocery.resultDisplayFormat.CARDS",
					},
				],
			},
		},

		{
			type: "radio",
			name: "resultOrderType",
			required: false,
			showField: (proxy) => !isGenAI(proxy),
			props: {
				labelKey: "editbreak.steps.grocery.resultOrderType",
				options: [
					{
						value: "NATURAL",
						textKey: "editbreak.steps.grocery.resultOrderType.NATURAL",
					},
					{
						value: "ALPHABETICAL",
						textKey: "editbreak.steps.grocery.resultOrderType.ALPHABETICAL",
					},
				],
			},
		},

		{
			subSection: true,
			// key: "editbreak.steps.grocery.resultLink.header",
			sectionWrapper: IndexedSubSectionWrapper,
			props: {
				headerKey: "editbreak.steps.grocery.resultLink.header",
			},
			fields: [
				{
					type: "image",
					name: "globalCTAImageId",
					idFor: "globalCTAImage",
					required: false,
					props: {
						labelKey: "Global Product Image",
						imageType: "custom",
					},
					showField: (proxy) => {
						// console.log(`proxy.grandParentCurrentResource.hasGenAI`, proxy.grandParentCurrentResource.hasGenAI)
						// return proxy.grandParentCurrentResource.hasGenAI === true;

						// console.log(proxy.currentResource) //  grocery
						// console.log(proxy.parentCurrentResource) //
						// console.log(proxy.grandParentCurrentResource) //
						// console.log(proxy.grandParentCurrentResource.resultDisplayType)
						return proxy.currentResource.hasGenAI;
					},
				},
				{
					type: "contenteditable",
					name: "globalKeyIngredient",
					showField: (proxy) => {
						return proxy.currentResource.hasGenAI;
					},
					required: false,
					props: {
						labelKey: "Key Ingredient",
					},
				},
				{
					type: "hardcodedText",
					props: {
						text: "Optionally include CTA buttons.",
					},
				},
				{
					name: "resultDropdownButtons",
					subSection: true,
					resource: true,
					collection: true,
					sectionWrapper: IndexedSubSectionWrapper,
					deletable: true,
					canDelete: (formProxy) => {
						// logic like this would force at least one item
						//   var parentReview = formProxy.parentCurrentResource;
						//   return parentReview.products && parentReview.products.length > 1;
						return true;
					},
					sortable: true,
					sortableName: "linksOrder",
					resourceType: ResourceApi.Types.GroceryDropdownButton,
					toggleSortLabelKey:
						"editbreak.steps.grocery.resultLink.reorder_toggle",
					props: {
						headerKey: "editbreak.steps.grocery.resultLink.section_header",
						getCustomSectionHeader: (item, sectionIndex) => {
							console.log("custom header", item);
							if (!item.links) {
								item.links = [];
							}

							let links = item.links.filter((item) => {
								return item.deleted === false;
							});
							if (links.length > 1) {
								return item.buttonCopy
									? item.buttonCopy
									: `dropdownbutton - ${sectionIndex + 1}`;
							} else if (links.length === 1) {
								return links[0].label;
							} else {
								return `dropdownbutton - ${sectionIndex + 1}`;
							}
							// return product.dropdownTitle
							// && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
						},
					},

					footerContent: createButtonSectionFactory(
						ResourceApi.Types.GroceryDropdownButton
					),

					fields: [
						{
							type: "hardcodedText",
							key: "links-helper",
							props: {
								text: "If you include a single link, the UI will show a button. Incude multiple links and the UI will show a dropdown button.",
							},
						},
						{
							type: "contenteditable",
							name: "label",
							required: false,
							props: {
								labelKey: "Button Copy",
							},
							showField: (proxy) => {
								let links = proxy.currentResource.links.filter((item) => {
									return item.deleted === false;
								});

								return links.length > 1;
							},
						},
						{
							name: "links",
							subSection: true,
							resource: true,
							collection: true,
							sectionWrapper: IndexedSubSectionWrapper,
							deletable: true,
							canDelete: (formProxy) => {
								// logic like this would force at least one item
								//   var parentReview = formProxy.parentCurrentResource;
								//   return parentReview.products && parentReview.products.length > 1;
								return true;
							},
							sortable: true,
							sortableName: "linksOrder",
							resourceType: ResourceApi.Types.GroceryDropdownButtonLink,
							toggleSortLabelKey:
								"editbreak.steps.grocery.resultLink.reorder_toggle",
							props: {
								//headerKey: 'editbreak.steps.grocery.resultLink.section_header',
								getCustomSectionHeader: (item, sectionIndex) => {
									return item.label ? item.label : `Link - ${sectionIndex + 1}`;
									// return product.dropdownTitle
									// && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
								},
							},

							footerContent: createButtonSectionFactory(
								ResourceApi.Types.GroceryDropdownButtonLink
							),

							fields: [
								{
									type: "contenteditable",
									name: "label",
									required: false,
									props: {
										labelKey: "Label",
									},
								},
								{
									type: "text",
									name: "url",
									required: false,
									props: {
										labelKey: "Url",
									},
								},
							],
						},
					],
				},
			],
		},
	],
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/grocery-checklist.js